import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import {
  useCauseUploadAttachmentsMutation,
  useCreateCauseAnalysisMutation,
} from "../../../features/api/apiSlice";
import { isDev } from "../../../utils/dev";
import { getErrorMessage } from "../../../utils/errors/errors";
import { FormCauseAnalysisSchema } from "./FormCauseAnalysis";

type Options = {
  hideModal: () => void;
  refetchEvent: () => void;
};
export default function useSubmit({ hideModal, refetchEvent }: Options) {
  const [createCause, { isLoading }] = useCreateCauseAnalysisMutation();

  const [postAttachments, { isLoading: isPostingAttachments }] =
    useCauseUploadAttachmentsMutation();

  const createCauseAnalaysis: SubmitHandler<FormCauseAnalysisSchema> =
    useCallback(
      async (values) => {
        try {
          if (isDev) {
            console.log("createCauseAnalaysis values");
            console.log(values);
          }

          const createdCause = await createCause(values).unwrap();

          console.log("createdCause");
          console.log(createdCause);

          notification.success({
            message: "L'analyse des causes a Ã©tÃ© crÃ©Ã©e",
          });

          // 2) Upload attachments (linked to actions)
          const files: undefined | File[] = values?.attachedFiles;

          if (files?.length) {
            const responseUpload = await postAttachments({
              causeId: createdCause.id,
              files,
            }).unwrap();
            console.log("Response Upload", responseUpload);
            // Show success notification
            notification.success({
              message: "PiÃ¨ces jointes ajoutÃ©es",
            });
          }

          hideModal();
          refetchEvent();
        } catch (error) {
          console.error("Cause-analysis error:", error);
          notification.error({
            message: "Erreur",
            description: getErrorMessage(error),
          });
        }
      },
      [createCause, hideModal, postAttachments, refetchEvent],
    );

  return {
    createCauseAnalaysis,
    isLoading: isLoading || isPostingAttachments,
  };
}
